import { defineComponent as V, reactive as C, ref as F, watch as d, computed as M, createBlock as o, openBlock as c, mergeProps as w, withCtx as n, createVNode as f, createCommentVNode as h, withModifiers as m, nextTick as z } from "vue";
import { _ } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import { _ as B } from "./Input.vue_vue_type_script_setup_true_lang-CfPxGene.js";
import { _ as x } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import { d as P } from "./debounce-BJrVv5jG.js";
import { i as $, b as E } from "./baseMixins-HJffeBsS.js";
import { _ as N } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const U = /* @__PURE__ */ V({
  __name: "SearchInput",
  props: {
    ...E,
    ...$,
    placeholder: {
      type: String,
      default: "Search..."
    },
    autoSearch: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue", "input:focus", "input:blur", "clear-search"],
  setup(b, { expose: I, emit: S }) {
    const a = b, e = C({
      searchText: "",
      isFocusing: !1
    }), s = F(null), r = S;
    d(
      () => a.modelValue,
      (t) => {
        e.searchText = t;
      }
    );
    const u = P((t) => {
      r("update:modelValue", t), s.value.focusInput();
    }, 500), l = (t) => {
      u(e.searchText);
    }, T = () => {
      e.searchText = "", s.value && s.value.focusInput(), r("clear-search");
    }, i = M(() => !a.autoSearch || a.autoSearch && !e.searchText), y = (t) => {
      e.isFocusing = !0, r("input:focus", t);
    }, v = (t) => {
      e.isFocusing = !1, r("input:blur", t);
    };
    d(
      () => e.searchText,
      (t) => {
        r("update:modelValue", t), a.autoSearch && u(e.searchText);
      }
    );
    function k() {
      z(() => {
        s.value?.focusInput();
      });
    }
    return I({
      focusInput: k
    }), (t, p) => (c(), o(B, w({ class: "search-input" }, a, {
      "is-dark": !0,
      modelValue: e.searchText,
      "onUpdate:modelValue": p[0] || (p[0] = (g) => e.searchText = g),
      onHandleEnterKeyUp: l,
      class: [a.size.toLowerCase(), { "manual-search": i.value }, { focusing: e.isFocusing }],
      "onInput:focus": y,
      "onInput:blur": v,
      ref_key: "arboInput",
      ref: s
    }), {
      append: n(() => [
        f(x, {
          content: !a.disable && e.searchText ? "Clear search" : "",
          delay: [300, 0]
        }, {
          default: n(() => [
            !a.disable && e.searchText ? (c(), o(_, {
              key: 0,
              class: "search-input__remove-btn",
              type: "primary",
              suffixIcon: "Xmark",
              onClick: m(T, ["stop"]),
              label: ""
            })) : h("", !0)
          ]),
          _: 1
        }, 8, ["content"]),
        f(x, {
          content: !a.disable && e.searchText ? "Search" : "",
          delay: [300, 0]
        }, {
          default: n(() => [
            i.value ? (c(), o(_, {
              key: 0,
              class: "search-input__search-btn",
              type: "tertiary",
              suffixIcon: "MagnifyingGlass",
              onClick: m(l, ["stop"]),
              label: "",
              disable: a.disable || !e.searchText,
              size: a.size
            }, null, 8, ["disable", "size"])) : h("", !0)
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _: 1
    }, 16, ["modelValue", "class"]));
  }
}), A = /* @__PURE__ */ N(U, [["__scopeId", "data-v-cdeb0a20"]]);
export {
  A as default
};
